import React, { useEffect, useMemo, useRef } from "react";
import { SGeneralForms, SSegmentedTabs } from "shj-components";
import { lendingInstitutionsAdd, lendingInstitutionsEdit } from '@/services/fmsConfig'
const AddOrEdit = (props) => {
  const { editRef, setLoading, fn, record, onCancel } = props;
  const ref = useRef();

  const onFormRef = () => {
    const { onFormRef } = ref.current || {};
    return onFormRef?.()
  }

  useEffect(() => {

  }, [props.record]);

  const getOptions = async () => {
  }

  const onFinish = () => {
    onFormRef()?.validateFields().then(values => {
      setLoading(true)
      if(values?.id){
        lendingInstitutionsEdit({...values, enabled:values?.enabled ? true : false}).then((res)=>{
          setLoading(false)
          onCancel()
          fn()
        }).finally(() => {
          setLoading(false)
        })
      }else{
        lendingInstitutionsAdd({...values, enabled:values?.enabled ? true : false}).then((res)=>{
          setLoading(false)
          onCancel()
          fn()
        }).finally(() => {
          setLoading(false)
        })
      }
      
    })
  }

  if (editRef) editRef.onFinish = onFinish
  const reqMeg = '不能为空'
  return <>
    <SGeneralForms
      initialValues={props.record}
      ref={ref}
      layout={'vertical'}
      titleMode={'edit'}
      configs={[{
        formItem: [
          { label: 'id', name: 'id', hidden: true },
          {
            label: '机构编码',
            name: 'institutionNumber',
            spanCol: 12,
            comConfig: {
              disabled: record?.id,
            },
          },
          {
            label: '机构名称', name: 'institutionName', spanCol: 12,
            required: true,
            rules: [{ required: true, message: reqMeg }],
            comConfig: {
              maxLength: 100,
            }
          },
          {
            label: '纳税人识别号', name: 'taxNumber', spanCol: 12,
            required: true,
            rules: [{ required: true, message: reqMeg }],
            comConfig: {
              maxLength: 100,
            }
          },
          {
            label: '开户行名称', name: 'accountName', spanCol: 12,
            required: true,
            rules: [{ required: true, message: reqMeg }],
            comConfig: {
              maxLength: 100,
            }
          },
          {
            label: '开户行网点', name: 'bankBranches', spanCol: 12,
            required: true,
            rules: [{ required: true, message: reqMeg }],
            comConfig: {
              maxLength: 100,
            }
          },
          {
            label: '银行账号', name: 'accountNo', spanCol: 12,
            required: true,
            rules: [{ required: true, message: reqMeg }],
            comConfig: {
              maxLength: 100,
            }
          },
          {
            label: '状态',
            name: 'enabled',
            type: 'switch',
            spanCol: 12,
            comConfig: {
              checkedChildren: '启用',
              unCheckedChildren: '禁用',
            },
          },
        ]
      }]}
    />
  </>
}

export default AddOrEdit
